"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _DataResponse = _interopRequireDefault(require("../models/DataResponse"));

var _HasMoreResponse = _interopRequireDefault(require("../models/HasMoreResponse"));

var _Storable = _interopRequireDefault(require("../models/Storable"));

/**
 * Relationship service.
 * @module ChiRhos/api/RelationshipApi
 * @version v1
 */
var RelationshipApi =
/*#__PURE__*/
function () {
  /**
   * Constructs a new RelationshipApi.
   * @alias module:ChiRhos/api/RelationshipApi
   * @class
   * @param {module:ChiRhos/ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ChiRhos/ApiClient#instance} if unspecified.
   */
  function RelationshipApi(apiClient) {
    (0, _classCallCheck2["default"])(this, RelationshipApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * @param {Object} opts Optional parameters
   * @param {String} opts.value
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
   */


  (0, _createClass2["default"])(RelationshipApi, [{
    key: "_acceptWithHttpInfo",
    value: function _acceptWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        value: opts['value']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Relationship/Accept', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "Accept",
    value: function Accept(opts) {
      return this._acceptWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_deleteWithHttpInfo",
    value: function _deleteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Relationship', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "Delete",
    value: function Delete(opts) {
      return this._deleteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.importIdentifier
     * @param {Boolean} opts.createDependencies  (default to false)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/Storable} and HTTP response
     */

  }, {
    key: "_importWithHttpInfo",
    value: function _importWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        ContentType: opts['contentType'],
        ContentDisposition: opts['contentDisposition'],
        Headers: opts['headers'],
        Length: opts['length'],
        Name: opts['name'],
        FileName: opts['fileName'],
        importIdentifier: opts['importIdentifier'],
        createDependencies: opts['createDependencies']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _Storable["default"];
      return this.apiClient.callApi('/api/Relationship/Import', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.importIdentifier
     * @param {Boolean} opts.createDependencies  (default to false)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/Storable}
     */

  }, {
    key: "Import",
    value: function Import(opts) {
      return this._importWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_getWithHttpInfo",
    value: function _getWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Relationship/Get', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "Get",
    value: function Get(opts) {
      return this._getWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * The sort applies to the order of the &#39;owned&#39; people returned, not the relationships. These are sorted internally.
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/HasMoreResponse} and HTTP response
     */

  }, {
    key: "_listForOwnedWithHttpInfo",
    value: function _listForOwnedWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _HasMoreResponse["default"];
      return this.apiClient.callApi('/api/Relationship/Owned/List', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * The sort applies to the order of the &#39;owned&#39; people returned, not the relationships. These are sorted internally.
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/HasMoreResponse}
     */

  }, {
    key: "ListForOwned",
    value: function ListForOwned(opts) {
      return this._listForOwnedWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * The sort applies to the order of the &#39;owned&#39; people returned, not the relationships. These are sorted internally.
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/HasMoreResponse} and HTTP response
     */

  }, {
    key: "_listForOwnedAwaitingAcceptanceWithHttpInfo",
    value: function _listForOwnedAwaitingAcceptanceWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _HasMoreResponse["default"];
      return this.apiClient.callApi('/api/Relationship/Owned/ListAwaitingAcceptance', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * The sort applies to the order of the &#39;owned&#39; people returned, not the relationships. These are sorted internally.
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/HasMoreResponseRelationshipContainer}
     */

  }, {
    key: "ListForOwnedAwaitingAcceptance",
    value: function ListForOwnedAwaitingAcceptance(opts) {
      return this._listForOwnedAwaitingAcceptanceWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * If the current user is passed in, this will return all relationships for the current person AND any persons they are owner for
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_listForPersonWithHttpInfo",
    value: function _listForPersonWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Relationship/ListForPerson', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * If the current user is passed in, this will return all relationships for the current person AND any persons they are owner for
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "ListForPerson",
    value: function ListForPerson(opts) {
      return this._listForPersonWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/RelationshipConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_saveWithHttpInfo",
    value: function _saveWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Relationship', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/RelationshipConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "Save",
    value: function Save(opts) {
      return this._saveWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
  }]);
  return RelationshipApi;
}();

exports["default"] = RelationshipApi;
module.exports = exports.default;